module.exports = __webpack_public_path__ + "static/img/b29.8f988d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b29.jpg
// module id = edFl
// module chunks = 1